import { addRecord, addRecords } from '../helpers'
import * as types from '../mutation-types'

export default {
  state: {
    image_blueprints: [],
    image_flavors: [],
    image_groups: [],
    image_snapshots: [],
    image_tiers: []
  },
  mutations: {
    [types.ADD_IMAGE_BLUEPRINTS] (state, image_blueprints) {
      addRecords(state.image_blueprints, image_blueprints, 'image_blueprints')
    },
    [types.ADD_IMAGE_FLAVORS] (state, image_flavors) {
      addRecords(state.image_flavors, image_flavors, 'image_flavors')
    },
    [types.ADD_IMAGE_GROUPS] (state, image_groups) {
      addRecords(state.image_groups, image_groups, 'image_groups')
    },
    [types.ADD_IMAGE_SNAPSHOTS] (state, image_snapshots) {
      addRecords(state.image_snapshots, image_snapshots, 'image_snapshots')
    },
    [types.ADD_IMAGE_TIERS] (state, image_tiers) {
      addRecords(state.image_tiers, image_tiers, 'image_tiers')
    },
    [types.CLEAR_IMAGE_SNAPSHOTS] (state) {
      state.image_snapshots = []
    }
  },
  actions: {
    getImageSnapshots (context, payload) {
      axios.get('/api/image_snapshots')
        .then(function (response) {
          // success callback
          let snapshots = response.data
          // Add image snapshots
          context.commit(types.CLEAR_IMAGE_SNAPSHOTS)
          context.commit(types.ADD_IMAGE_SNAPSHOTS, snapshots.data)
        })
        .catch(function (error) {
          // error callback
        })
    },

    getImageTiers (context, payload) {
      axios.get('/api/image_tiers')
        .then(function (response) {
          // success callback
          let tiers = response.data
          // Add image tiers
          context.commit(types.ADD_IMAGE_TIERS, tiers.data)
          // Add included relationship data
          context.commit(types.ADD_IMAGE_GROUPS, tiers.included)
        })
        .catch(function (error) {
          // error callback
        })
    },

    loadImageSnapshot (context, payload) {
      let url = '/api/me/image_snapshots/' + payload.id + '/load'

      axios.post(url, payload.json)
        .then(function (response) {
          // success callback
          payload.self.getImageSnapshots()
          payload.self.getCurrentReservation()
        })
        .catch(function (error) {
          // error callback
          payload.self.getImageSnapshots()
          payload.self.getCurrentReservation()
        })
    },

    postImageSnapshot (context, payload) {
      let url = '/api/me/image_snapshots/'

      axios.post(url, payload.json)
        .then(function (response) {
          // success callback
          payload.self.getImageSnapshots()
          payload.self.getCurrentReservation()
        })
        .catch(function (error) {
          // error callback
          payload.self.getImageSnapshots()
          payload.self.getCurrentReservation()
        })
    },

    patchImageSnapshot (context, payload) {
      let url = '/api/me/image_snapshots/' + payload.id

      axios.patch(url, payload.json)
        .then(function (response) {
          // success callback
          payload.self.getImageSnapshots()
          payload.self.getCurrentReservation()
        })
        .catch(function (error) {
          // error callback
          payload.self.getImageSnapshots()
          payload.self.getCurrentReservation()
        })
    }
  }
}
